import { MenuItem, makeStyles, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles({
  root: {
    borderRadius: 4,
    backgroundColor: "#1A3036",
    color: "#F7F7F9",
    height: "35px",
    margin: (spacing) => `0 ${spacing}px`,
    padding: "8px 12px",
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  icon: {
    fill: "white",
    fontSize: "35px",
    top: "0px",
  },
});

interface ISelectMenu {
  menuItems: string[];
  onChange: (meter: string) => void;
  initialValue: string | undefined;
  disabled?: boolean;
  spacing?: number;
}

export const SelectMenu = ({
  onChange,
  menuItems,
  initialValue,
  disabled,
  spacing = 10,
}: ISelectMenu) => {
  const classes = useStyles(spacing);
  const [selectedItem, setSelectedItem] = useState(initialValue);
  const handleChange = (value: string) => {
    setSelectedItem(value);
    onChange(value);
  };

  useEffect(() => {
    if (initialValue) {
      setSelectedItem(initialValue);
    }
  }, [initialValue]);
  return (
    <Select
      className={classes.root}
      value={selectedItem}
      IconComponent={ExpandMoreIcon}
      disabled={disabled}
      inputProps={{
        classes: {
          icon: classes.icon,
        },
      }}
      onChange={(e) => handleChange(e.target.value as string)}
    >
      {menuItems.map((item, i) => {
        return (
          <MenuItem key={i} value={item}>
            {item}
          </MenuItem>
        );
      })}
    </Select>
  );
};
